/* eslint-disable */
if (location.hostname !== "localhost") {
  if (location.protocol !== "https:") {
    var locationULR = location.href.replace("www.", "");
    location.href = locationULR.replace("http://", "https://www.");
  } else if (location.protocol === "https:") {
    var locationULR = location.href;
    if (locationULR.indexOf("www.") < 0) {
      location.href = "https://www." + locationULR.replace("https://", "");
    }
  }
}

import React from "react";
import { render } from "react-dom";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import { getStore } from "./store";

import "./common/css/font-awesome.min.css";
import "./common/css/bootstrap.min.css";
import "@koomipay/react-legacy/dist/koomipay.css";
import "./common/css/custom.css";
import "./common/css/responsive.css";
import "./common/css/slick.css";

import Home from "./components/Home/Home";
import Products from "./components/Products/Products";
import ProductDetail from "./components/Products/ProductDetail";
import Checkout from "./components/Checkout/Checkout";
import Thankyou from "./components/Checkout/Thankyou";
import Myaccount from "./components/Myaccount/Myaccount";
import Pages from "./components/Pages/Pages";
import Logout from "./components/Myaccount/Logout";
import Orders from "./components/Myaccount/Orders";
import Mypromotions from "./components/Myaccount/Mypromotions";
import Myvoucher from "./components/Myaccount/Myvoucher";
import Mynotifications from "./components/Myaccount/Notifications";

import Rewards from "./components/Myaccount/Rewards";
import Account from "./components/Account/Account";
import Resetpassword from "./components/Account/Resetpassword";

import ContactUs from "./components/Pages/ContactUs";

/* import Prmotionevents from "./components/Pages/Prmotionevents"; */
import Partnermerchant from "./components/Pages/Partnermerchant";
import Events from "./components/Pages/Events";

import Catering from "./components/Catering/Catering";
import CateringThankyou from "./components/Catering/Thankyou";
import Viewmenu from "./components/Catering/Viewmenu";
import Payment from "./components/Payment/Payment";
import PayThank from "./components/Payment/Thankyou";
import Reservation from "./components/Reservation/Reservation";
import Reservationsummary from "./components/Reservation/Reservationsummary";
import Reservationthankyou from "./components/Reservation/Reservationthankyou";
import Outletsnew from "./components/Pages/Outletsnew";
import Promotions from "./components/Pages/Promotions";
import Galleryimages from "./components/Pages/Galleryimages";
import Refpage from "./components/Layout/Refpage";
import Ourvideos from "./components/Pages/Ourvideos";
import GalleryDetail from "./components/Pages/GalleryDetail";
import Gallery from "./components/Pages/Gallery";
import Placeorder from "./components/Checkout/Placeorder";
import Placeordercatering from "./components/Payment/Placeordercatering";

import KoomipayComplete from "./components/Checkout/KoomipayComplete";

import Page404 from "./Page404";

const store = getStore();

render(
  <Provider store={store}>
    <Router>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path={"/products/:slugType/:slugValue/:proSlug"} component={ProductDetail} />
        <Route path={"/products/:slugType/:slugValue"} component={Products} />
        <Route path="/products" component={Products} />
        <Route path="/checkout/koomipay-complete" component={KoomipayComplete} />
        <Route path="/checkout" component={Checkout} />
        <Route path="/thankyou/:orderId" component={Thankyou} />

        <Route path="/myaccount" component={Myaccount} />
        <Route path="/mypromotions" component={Mypromotions} />
        <Route path="/myorders" component={Orders} />
        <Route path="/rewards" component={Rewards} />
        <Route path="/myvouchers" component={Myvoucher} />
        <Route path="/notifications" component={Mynotifications} />
        <Route path="/placeorder" component={Placeorder} />
        <Route path="/placeordercatering" component={Placeordercatering} />

        <Route path="/account/activation/:activationKey" component={Account} />
        <Route path="/account/resetpassword/:resetKey" component={Resetpassword} />

        <Route path="/about-us" component={Pages} />
        <Route path="/terms-conditions" component={Pages} />
        <Route path="/privacy-policy" component={Pages} />
        <Route path="/contact-us" component={ContactUs} />
        <Route path="/locations" component={Outletsnew} />
        <Route path="/promotion-events" component={Promotions} />

        <Route path="/view-menu" component={ContactUs} />

        {/* <Route path="/promotion-events" component={Prmotionevents} /> */}
        <Route path="/participating-merchants" component={Partnermerchant} />
        <Route path="/events" component={Events} />

        <Route path="/catering/thankyou/:orderId" component={CateringThankyou} />
        <Route path="/catering" component={Catering} />
        <Route path="/viewmenu" component={Viewmenu} />
        <Route path="/payment/thankyou" component={PayThank} />
        <Route path={"/payment/:orderId/:paymentId"} component={Payment} />
        <Route path="/payment" component={Payment} />

        <Route path="/reservation" component={Reservation} />
        <Route path="/reservation-summary" component={Reservationsummary} />
        <Route path="/reservation-thankyou" component={Reservationthankyou} />
        <Route path="/logout" component={Logout} />
        <Route path="/ourvideos" component={Ourvideos} />
        <Route path="/gallery/:page_slug" component={GalleryDetail} />
        <Route path="/gallery" component={Gallery} />
        <Route path={"/refpage/:slugtext"} component={Refpage} />
        <Route path="/:page_slug" component={Pages} />
        <Route component={Page404} />
      </Switch>
    </Router>
  </Provider>,

  document.getElementById("root"),
);
